import { RequestProvider } from '@/shared/providers/request.provider';
import { Placeholder } from '../models/class-builder.models';
import { PLACEHOLDER_API, PLACEHOLDER_PARAMS } from '../values/placeholder.values';
import { CreatePlaceholderParams } from '../params/class-builder.params';

class PlaceholderServiceClass {
  getPlaceholders(classId: string, calculateTime: boolean): Promise<any> {
    const req = PLACEHOLDER_API.GET_PLACEHOLDERS
      .replace(PLACEHOLDER_PARAMS.CLASS_ID, classId)
      .replace(PLACEHOLDER_PARAMS.CALCULATE_TIME, calculateTime.toString());

    return RequestProvider.get(req);
  }

  addPlaceholder(
    classId: number,
    placeholder: CreatePlaceholderParams
  ): Promise<any> {
    const req = PLACEHOLDER_API.ADD_PLACEHOLDER
      .replace(PLACEHOLDER_PARAMS.CLASS_ID, classId.toString())
    
    return RequestProvider.post(req, { ...placeholder });
  }

  updatePlaceholder(
    classId: number,
    placeholderId: number,
    placeholder: CreatePlaceholderParams
  ): Promise<any> {
    const req = PLACEHOLDER_API.UPDATE_PLACEHOLDER
      .replace(PLACEHOLDER_PARAMS.CLASS_ID, classId.toString())
      .replace(PLACEHOLDER_PARAMS.PLACEHOLDER_ID, placeholderId.toString())

    return RequestProvider.put(req, { ...placeholder });
  }

  deletePlaceholder(classId: number, placeholderId: number): Promise<any> {
    const req = PLACEHOLDER_API.DELETE_PLACEHOLDER
      .replace(PLACEHOLDER_PARAMS.CLASS_ID, classId.toString())
      .replace(PLACEHOLDER_PARAMS.PLACEHOLDER_ID, placeholderId.toString())

    return RequestProvider.remove(req);
  }

  relatePlaceholder(classId: string, scheduleIds: number[], placeholderIds: number[]): Promise<any> {
    const req = PLACEHOLDER_API.RELATE_PLACEHOLDERS
      .replace(PLACEHOLDER_PARAMS.CLASS_ID, classId)

    return RequestProvider.put(req, { scheduleIds, placeholderIds });
  }

  unrelatePlaceholder(
    classId: string,
    scheduleIds: number[],
    placeholderIds: number[]
  ): Promise<any> {
    const req = PLACEHOLDER_API.UNRELATE_PLACEHOLDERS
      .replace(PLACEHOLDER_PARAMS.CLASS_ID, classId)

    return RequestProvider.remove(req, { scheduleIds, placeholderIds });
  }
  
  getSchedulePlaceholder(classId: number, placeholderId: number) {
    const req = PLACEHOLDER_API.GET_SCHEDULE_PLACEHOLDER
      .replace(PLACEHOLDER_PARAMS.CLASS_ID, classId.toString());

    return RequestProvider.get(req, { placeholderId });
  }

  assignMainPlaceholderToSchedule(classId: number, scheduleId: number, placeholderId: number, dates: string[]) {
    const req = PLACEHOLDER_API.ASSIGN_MAIN_PLACEHOLDER_TO_SCHEDULE
    .replace(PLACEHOLDER_PARAMS.CLASS_ID, classId.toString())
    .replace(PLACEHOLDER_PARAMS.SCHEDULE_ENTRY_ID, scheduleId.toString())
    .replace(PLACEHOLDER_PARAMS.PLACEHOLDER_ID, placeholderId.toString());

    return RequestProvider.put(req, dates);
  }

  assignPlaceholdersToSchedule(
    classId: number,
    scheduleId: number,
    dates: {
      placeholderId: number,
      date: string
    }
  ) {
    const req = PLACEHOLDER_API.ASSIGN_PLACEHOLDERS_TO_SCHEDULE
      .replace(PLACEHOLDER_PARAMS.CLASS_ID, classId.toString())
      .replace(PLACEHOLDER_PARAMS.SCHEDULE_ENTRY_ID, scheduleId.toString());
    
    return RequestProvider.put(req, dates);
  }
}

export const PlaceholderService = new PlaceholderServiceClass();